import React, { useContext } from "react";
import { Link } from "gatsby";
import UserContext from "../contexts/UserContext";

const Navbar: React.FC<{}> = () => {
  const { user, signout, isSignedIn } = useContext(UserContext);
  return (
    <nav className="flex p-4">
      <div className="">
        <Link to="/">Logo</Link>{" "}
      </div>
      {!isSignedIn() && (
        <Link to="/signin" className="px-4 focus:outline-none">
          Se connecter
        </Link>
      )}
      {!isSignedIn() && (
        <Link to="/signup" className="px-4 focus:outline-none">
          S'enregistrer
        </Link>
      )}
      {isSignedIn() && (
        <button className="px-4 focus:outline-none" onClick={signout}>
          Se déconnecter
        </button>
      )}
      {isSignedIn() && (
        <div className="px-4 focus:outline-none">{user?.username}</div>
      )}
      <button className="snipcart-checkout">Cart</button>
    </nav>
  );
};

export default Navbar;
